import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT } from '../authentication/constants'
import { exportStatuses } from '../plan-viewer/constants'

const initialState = fromJS({
  uploadStatus: {},
  downloadStatus: {}
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_UPLOAD_STATUS:
      return state.delete('getUploadStatusError')
    case actionTypes.GET_UPLOAD_STATUS_DONE: {
      const uploadStatus = {}
      action.uploadStatus.forEach((status) => {
        uploadStatus[status.id] = status
      })
      if (action.clearPrevious) {
        return state.set('uploadStatus', fromJS(uploadStatus))
      }
      return state.set(
        'uploadStatus',
        state.get('uploadStatus').mergeDeep(fromJS(uploadStatus))
      )
    }
    case actionTypes.GET_UPLOAD_STATUS_ERROR:
      return state.set('getUploadStatusError', action.error)

    case actionTypes.CANCEL_ALL_IMPORTS: {
      let newState = state
      newState.get('uploadStatus').forEach((status, id) => {
        if (
          status.get('progress') !== 100 &&
          !['Failed', 'Canceled', 'Succeeded'].includes(status.get('stage'))
        ) {
          newState = newState.setIn(
            ['uploadStatus', id],
            status.set('stage', 'CancelInProgress')
          )
        }
      })
      return newState
    }
    case actionTypes.CANCEL_ALL_IMPORTS_DONE: {
      let newState = state
      newState.get('uploadStatus').forEach((status, id) => {
        if (status.get('stage') === 'CancelInProgress') {
          newState = newState.setIn(
            ['uploadStatus', id],
            status.set('stage', 'Canceled')
          )
        }
      })
      return newState
    }
    case actionTypes.CANCEL_ALL_IMPORTS_ERROR: {
      let newState = state
      newState.get('uploadStatus').forEach((status, id) => {
        if (status.get('stage') === 'CancelInProgress') {
          newState = newState.setIn(
            ['uploadStatus', id],
            status.set('stage', 'CancelFailed')
          )
        }
      })
      return newState
    }

    case actionTypes.HIDE_IMPORT: {
      let newState = state
      if (!Array.isArray(action.importId)) {
        newState = newState.setIn(
          ['uploadStatus', action.importId, 'hidden'],
          true
        )
      } else {
        newState.get('uploadStatus').forEach((status, id) => {
          if (
            (status.get('progressInPercent') === 100 &&
              status.get('stage') === 'SUCCEEDED') ||
            status.get('stage') === 'CANCELED' ||
            status.get('stage') === 'FAILED'
          ) {
            newState = newState.setIn(
              ['uploadStatus', id],
              status.set('hidden', true)
            )
          }
        })
      }
      return newState
    }
    case actionTypes.HIDE_ALL_FINISHED_IMPORTS: {
      let newState = state
      newState.get('uploadStatus').forEach((status, id) => {
        if (
          (status.get('progressInPercent') === 100 &&
            status.get('stage') === 'SUCCEEDED') ||
          status.get('stage') === 'CANCELED' ||
          status.get('stage') === 'FAILED'
        ) {
          newState = newState.setIn(
            ['uploadStatus', id],
            status.set('hidden', true)
          )
        }
      })
      return newState
    }
    case actionTypes.SET_IMPORTS_AS_LOADED: {
      let newState = state
      newState.get('uploadStatus').forEach((status, id) => {
        if (
          status.get('stage') === 'SUCCEEDED' ||
          status.get('progressInPercent') === 100
        ) {
          newState = newState.setIn(['uploadStatus', id, 'loaded'], true)
        }
      })
      return newState
    }
    case actionTypes.SET_DOWNLOAD_STATUS: {
      return state.setIn(['downloadStatus', action.downloadId], {
        ...state.getIn(['downloadStatus', action.downloadId]),
        ...action.data
      })
    }
    case actionTypes.REMOVE_DOWNLOAD_STATUS:
      return state.setIn(['downloadStatus', action.downloadId], {
        ...state.getIn(['downloadStatus', action.downloadId]),
        hidden: true
      })
    case actionTypes.HIDE_ALL_FINISHED_EXPORTS: {
      let newState = state
      newState.get('downloadStatus').forEach((status, id) => {
        if (
          status.progress === 100 ||
          status.status === exportStatuses.FAILED ||
          status.status === exportStatuses.EXPIRED
        ) {
          newState = newState.setIn(['downloadStatus', id], {
            ...status,
            hidden: true
          })
        }
      })
      return newState
    }
    case actionTypes.CANCEL_ALL_EXPORTS: {
      let newState = state
      newState.get('downloadStatus').forEach((status, id) => {
        if (
          status.progress !== 100 &&
          status.status !== exportStatuses.FAILED &&
          status.status !== exportStatuses.EXPIRED
        ) {
          newState = newState.setIn(['downloadStatus', id], {
            ...status,
            hidden: true
          })
        }
      })
      return newState
    }
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
